import { Layer } from '../../../models/layer-settings';

const activeLayerCountsByType = (overlays: Layer[]) => {
  const layerCounts = {
    mbtiles_layer_count: 0,
    xyz_layer_count: 0,
    geojson_layer_count: 0,
    fulcrum_layer_count: 0,
    wms_layer_count: 0,
    public_feature_service_layer_count: 0,
    private_feature_service_layer_count: 0,
    enterprise_feature_service_layer_count: 0,
  };

  const typeOfFeatureService = (layer: Layer) => {
    const { origin, esriAppId } = layer;
    if (origin === 'fulcrum') {
      return 'public';
    }

    return esriAppId ? 'enterprise' : 'private';
  };

  overlays.forEach((layer) => {
    if (layer.type === 'feature-service') {
      const layerTypeKey = `${typeOfFeatureService(layer)}_feature_service_layer_count`;
      layerCounts[layerTypeKey] += 1;
    } else {
      const layerTypeKey = `${layer.type}_layer_count`;
      layerCounts[layerTypeKey] += 1;
    }
  });

  return layerCounts;
};

export default activeLayerCountsByType;
